export default __webpack_public_path__ + "cc66630554a94e27282120097d1d51d5.svg";